import React from "react";
import { DefaultLabel } from "../../components/DefaultLabel";

export function MissingWidget(props) {
  const { ui, config } = props;
  const widgetId = ui.id;

  let content = ui.widgetType;
  if (ui.widgetType === "MissingWidget") content += ": '" + config + "'";
  content = "[" + content + "]";

  const missingStyle = {
    height: "100%",
    width: "100%",
    border: "1px dashed grey",
    backgroundColor: "lightyellow",
    padding: "0px 5px"
  };

  return (
    <div id={widgetId} style={missingStyle}>
      <DefaultLabel value={content} />
    </div>
  );
}
